import { useContext } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { visibleLaunchpadItems } from "../../components/navigation/navItems";
import { ACCESS_LEVEL } from "../../utils/hooks/useAccessLevel";
import { UserContext } from "../../utils/contexts/UserContext";
import useDashboardView from "../../utils/hooks/useDashboardView";
import SchoolDashboard from "./SchoolDashboard";
import TeacherDashboard from "./teacher/TeacherDashboard";

export default function Home() {
  const { t } = useTranslation();
  const { view } = useDashboardView();
  const { user } = useContext(UserContext);

  if (view === ACCESS_LEVEL.SCHOOL) return <SchoolDashboard />;
  if (view === ACCESS_LEVEL.TEACHER) return <TeacherDashboard />;

  // No dashboard permission (e.g. account-manager-only): a launchpad of the
  // same nav registry the sidebar shows, instead of a dead end.
  const items = visibleLaunchpadItems(user).filter((item) => item.to !== "/");

  return (
    <div className="flex-1 bg-slate-50 p-6">
      <div className="max-w-2xl mx-auto mt-24">
        <h2 className="text-lg font-bold text-slate-700 text-center">
          {t("home.launchTitle")}
        </h2>
        <p className="mt-2 text-sm text-slate-500 text-center">
          {items.length > 0 ? t("home.launchSubtitle") : t("home.noAccessBody")}
        </p>
        {items.length > 0 && (
          <div className="mt-8 grid gap-4 sm:grid-cols-2">
            {items.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className="flex items-center gap-4 rounded-2xl border border-slate-200 bg-white p-5 shadow-sm transition hover:border-indigo-300 hover:shadow-md"
              >
                {item.accent ? (
                  // Accent items ship a self-framed icon — don't double-box it.
                  <div className="flex h-11 w-11 shrink-0 items-center justify-center">
                    {item.icon}
                  </div>
                ) : (
                  <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-indigo-50 text-indigo-600">
                    {item.icon}
                  </div>
                )}
                <span className="text-sm font-semibold text-slate-700">
                  {t(item.labelKey)}
                </span>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
